export const ErcotLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="2440"
    height="901"
    viewBox="0 0 165.1680145 61.0065308"
    enableBackground="new 0 0 165.1680145 61.0065308"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path
        fill="var(--theme-ui-colors-ercotLogo)"
        d="M21.4248009,35.7047119c-2.1049995,6.7360229-6.3560028,9.8720093-13.0620003,9.8720093
		c-3.3300018,0-5.6850014-0.8399658-7.0009995-2.5C-0.1292,41.1957397-0.3972015,38.1557617,0.5648003,34.041748
		l2.2929993-9.8029785c1.8670006-7.9810181,6.3160019-11.8600464,13.6020012-11.8600464
		c3.3289986,0,5.6839981,0.842041,7.0009995,2.5020142c1.4910011,1.8800049,1.7589989,4.9199829,0.7970009,9.0339966
		l-1.1340027,4.992981c-0.1639977,0.7400513-0.8769989,0.6630249-0.8769989,0.6630249H8.2557983
		c-0.5569992,0-0.7799988,0.0250244-0.9039993,0.5570068l-1.1279984,4.8309937
		c-0.5559998,2.375-0.4160004,4.0460205,0.4259987,5.1090088c0.644001,0.8109741,1.6689987,1.2229614,3.0480003,1.2229614
		c3.0089989,0,5.0180016-1.9459839,5.9729996-5.7839966c0.132-0.4319458,0.5470009-0.4199829,0.5470009-0.4199829h4.7680016
		C20.9858017,35.086731,21.6598015,35.041748,21.4248009,35.7047119 M15.1248016,16.6657104
		c-3.0670013,0-5.0950012,2.0220337-6.0270004,6.0080566l-0.321003,1.492981
		c-0.0589981,0.2520142-0.079998,0.5460205,0.0279999,0.7810059c0.1500015,0.3289795,0.3800011,0.3359985,0.8490028,0.3359985
		h7.6870003c0.5579987,0,0.7389984-0.0780029,0.8639984-0.6099854l0.3930016-1.6760254
		c0.5559998-2.375,0.4169998-4.0469971-0.4250031-5.1090088C17.528801,17.0777588,16.5028,16.6657104,15.1248016,16.6657104"
      />
      <path
        fill="var(--theme-ui-colors-ercotLogo)"
        d="M47.8470993,12.847168c-0.2520065,1.0780029-0.8710022,3.7230225-1.1170044,4.7740479
		c-0.0559998,0.2399902-0.2959976,0.3899536-0.5360031,0.3319702c-0.984993-0.2379761-2.0319977-0.4190063-3.5939941-0.4190063
		c-2.6360016,0-5.840004,1.5700073-6.6470032,5.0159912l-5.159996,22.0610352
		c-0.0470047,0.2019653-0.2280045,0.3460083-0.4360046,0.3460083H25.285099c-0.2280006,0-0.3959999-0.2130127-0.3440018-0.4349976
		l7.291996-31.177002c0.0480042-0.2030029,0.2280045-0.3460083,0.4360046-0.3460083l4.4599991-0.0029907
		c0.4229965,0,0.6719971,0.0739746,0.5690002,0.4840088l-0.1050034,0.7379761
		c-0.1269989,0.7379761,0.3899994,0.7799683,1.0870056,0.2639771c1.6639938-1.230957,4.548996-2.7669678,8.7979965-2.1779785
		C47.7360992,12.34021,47.9060974,12.5932007,47.8470993,12.847168"
      />
      <path
        fill="var(--theme-ui-colors-ercotLogo)"
        d="M66.9423981,33.7240601c0.2049942,0,0.3579941,0.1970215,0.3079987,0.3960571
		c-1.9280014,7.7149658-6.3479996,11.4569702-13.5050049,11.4569702c-3.3289948,0-5.6839981-0.8410034-7.0009995-2.5009766
		c-1.4909973-1.8810425-1.7589951-4.9200439-0.7959976-9.0350342l2.2929993-9.802002
		c1.8660049-7.980957,6.3160019-11.8599854,13.6019974-11.8599854c3.2770004,0,5.6090012,0.8109741,6.9309998,2.4130249
		c1.3610001,1.6499634,1.7480011,4.2459717,1.1529999,7.7209473c-0.0479965,0.2790527-0.2910004,0.4830322-0.572998,0.4820557
		c-1.1289978,0-3.9160004-0.0020142-4.9639969-0.0040283c-0.2109985,0-0.3619995-0.1959839-0.3190002-0.4019775
		c0.4469986-2.1680298,0.276001-3.7020264-0.5149994-4.7000122c-0.6440048-0.8120117-1.6700058-1.2230225-3.0480042-1.2230225
		c-3.0670013,0-5.0950012,2.0209961-6.0279999,6.0079956l-2.8740005,12.2839966
		c-0.5550003,2.375-0.4160004,4.0469971,0.427002,5.1090088c0.6439972,0.8120117,1.6689987,1.2230225,3.0469971,1.2230225
		c3.0680008,0,5.0960007-2.0209961,6.0279999-6.0079956l0.2940063-1.2560425
		c0.0410004-0.177002,0.1989975-0.302002,0.3809967-0.302002H66.9423981z"
      />
      <path
        fill="var(--theme-ui-colors-ercotLogo)"
        d="M79.6317978,45.5767212c-3.3300018,0-5.6850052-0.8399658-7.0009995-2.5
		c-1.4910049-1.8809814-1.7590027-4.9209595-0.7970047-9.0349731l2.2929993-9.8029785
		c1.8670044-7.9810181,6.3160019-11.8600464,13.602005-11.8600464c3.3299942,0,5.6839981,0.842041,7.0009995,2.5020142
		c1.4919891,1.8800049,1.7589874,4.9199829,0.7969971,9.0339966l-2.2929993,9.8029785
		C91.3667984,41.6977539,86.9177933,45.5767212,79.6317978,45.5767212 M86.3937988,16.6657104
		c-3.0670013,0-5.0950012,2.0220337-6.0270004,6.0080566l-2.8740005,12.2849731
		c-0.5550003,2.375-0.4160004,4.0460205,0.4259949,5.1090088c0.6440048,0.8109741,1.6689987,1.2229614,3.0470047,1.2229614
		c3.0680008,0,5.0960007-2.0219727,6.0279999-6.0089722l2.8730011-12.2839966
		c0.5569992-2.375,0.4169998-4.0469971-0.4250031-5.1090088C88.7977982,17.0777588,87.7717972,16.6657104,86.3937988,16.6657104"
      />
      <path
        fill="var(--theme-ui-colors-ercotLogo)"
        d="M103.6430054,17.7796021L98.6929932,38.942627
		c-0.4929962,2.1090088-0.3109894,3.7219849,0.5410004,4.7969971c0.9670105,1.2189941,2.8480072,1.8370361,5.5879974,1.8370361
		c1.4220123,0,2.2280121-0.0780029,2.9309998-0.2109985c0.1420135-0.026001,0.253006-0.1360474,0.2860107-0.276001
		l0.9649963-4.1290283c0.0350037-0.1480103-0.0780029-0.289978-0.2299957-0.289978h-1.2279968
		c-0.9960022,0-2.0230103-0.1110229-2.4850006-0.6920166c-0.503006-0.6350098-0.3300018-1.7369995-0.0559998-2.9110107
		l4.5269928-19.3499756c0.0919952-0.3690186,0.2980042-0.4310303,0.6470032-0.4310303h3.9769897
		c0.2260132,0,0.4220123-0.1569824,0.4740143-0.3770142l0.8209991-3.5099487
		c0.0479889-0.2050171-0.1070099-0.401001-0.3170013-0.401001h-4.0299988
		c-0.5340118-0.0310059-0.3390045-0.5120239-0.3390045-0.5120239l1.845993-7.934021
		c0.1160126-0.5669556-0.3759918-0.5489502-0.3759918-0.5489502h-4.9440002
		c-0.401001,0.0169678-0.4949951,0.3299561-0.4949951,0.3299561l-1.9410095,8.2560425
		c-0.0919952,0.3079834-0.1329956,0.4089966-0.5029907,0.4089966h-3.8740082c0,0-0.3289948,0-0.5139923,0.4530029
		l-0.802002,3.3699951c-0.1030121,0.3909912,0.348999,0.4649658,0.348999,0.4649658h3.7009888
		C103.2119904,17.2866211,103.7769928,17.2556152,103.6430054,17.7796021"
      />
      <path
        fill="#00ABC7"
        d="M153.9228973,29.7390137l-14.8600006,17.2329712
		c-0.1170044,0.1350098-0.3320007,0.0339966-0.298996-0.1389771l1.4769897-7.7139893
		c0.0570068-0.3030396-0.220993-0.5550537-0.5169983-0.467041l-3.4219971,1.0010376
		c-0.3150024,0.09198-0.552002,0.3579712-0.6060028,0.6799927l-3.3190002,19.756958
		c-0.0659943,0.5140381,0.3639984,0.717041,0.7120056,0.2950439l26.4129944-30.9700317
		c0.2020111-0.2369995,0.2220001-0.5759888,0.0540009-0.8309937c-1.6389923-2.4970093-4.04599-3.1729736-4.04599-3.1729736
		c-4.977005-1.9570313-10.7750092,1.506958-14.7320099,3.5999756c-10.125,5.3560181-16.1929932,0.3950195-17.4279938-0.8740234
		c-0.1309967-0.1359863-0.3130035-0.2099609-0.5039978-0.2099609l-4.3110046-0.0029907
		c-0.2290039,0-0.3650055,0.2600098-0.2299957,0.4400024c0.9440002,1.2649536,3.8129883,4.8219604,7.8369904,6.1469727
		c3.5680084,1.1749878,9.2700043,2.1669922,16.6809998-1.7860107l0.0960083-0.0549927
		c3.9850006-2.2730103,8.2339935-4.2160034,10.8560028-3.3280029
		C153.7749023,29.34198,154.1219025,29.4609985,153.9228973,29.7390137 M141.8009033,15.0979614
		c-6.2410126,3.6980591-10.4480133,4.1200562-11.9890137,3.2450562c-0.2070007-0.1170044-0.3109894-0.3560181-0.2609863-0.5930176
		l2.7879944-13.2720337c0.0370026-0.1749878,0.1929932-0.302002,0.3710022-0.302002l8.3399963-0.0059814
		c0.1389923,0,0.2420044,0.1279907,0.2100067,0.2650146l-1.5690002,6.8909912
		c-0.0490112,0.2119751,0.1619873,0.3829956,0.3609924,0.2949829l3.5850067-1.5969849
		c0.2419891-0.1049805,0.3479919-0.2630005,0.4219971-0.5269775l1.9869995-8.7800293
		C146.1308899,0.3469849,145.855896,0,145.4768982,0l-16.0820007,0.0130005c-0.2900085,0-0.5429993,0.2059937-0.6029968,0.4909668
		l-3.9670105,18.8569946c-0.048996,0.2320557,0.006012,0.4710083,0.1490021,0.6560059l0.4240112,0.5469971
		c0.3169861,0.4070435,2.2269897,2.3980103,6.3609924,2.3970337c2.7940063,0,6.1349945-0.934021,12.6179962-4.3049927
		c0.1009979-0.0540161,10.0400085-6.0170288,15.6959991,0.6350098c0.1269989,0.1489868,0.3090057,0.2379761,0.5070038,0.2379761
		l4.3079987-0.0020142c0.2160034,0,0.3529968-0.2420044,0.2389984-0.4219971
		C157.9218903,7.7399902,147.0898895,11.9649658,141.8009033,15.0979614"
      />
    </g>
  </svg>
);
